<!--
 * @Author: zyy
 * @Date: 2023-09-06 10:08:48
 * @LastEditTime: 2023-10-25 17:25:04
 * @FilePath: /tjzhsq-admin/src/views/platform/vip/level/index.vue
 * @Description: yahu~
 * 
-->
<template>
    <div class="member-manage app-region blank-t-v blank-l-h blank-r-h">
        <div>
            <a-button type="primary" @click="handleOpen()">新建</a-button>
        </div>
        <a-table class="mg-normal" :loading="table.loading" :columns="columns" :data-source="table.data" rowKey="id"
            :pagination="ipagination" @change="handlePageChange">
            <template slot="image" slot-scope="text, data">
                <dy-image :src="data.image_url"></dy-image>
            </template>
            <template slot="action" slot-scope="text, data">
                <a-space>
                    <a-button type="link" @click="handleOpen(data)">编辑</a-button>
                    <a-button type="link" @click="handleDelete(data)">删除</a-button>
                </a-space>
            </template>
        </a-table>
        <Edit @submit="getList" ref="editRef" v-if="showEdit" @close="showEdit = false"></Edit>
    </div>
</template>
  
<script>
import { TJListMixin } from '@/mixins/list.js'
import LevelService from '@/io/vip/grade.js'
import Edit from './edit.vue'

export default {
    name: 'LevelList',
    mixins: [TJListMixin],
    components: { Edit },
    data() {
        return {
            service: LevelService,
            columns: [
                {
                    title: 'id',
                    dataIndex: 'id'
                },
                {
                    title: '名称',
                    dataIndex: 'name'
                },
                {
                    title: '图片',
                    scopedSlots: { customRender: 'image' },
                },

                {
                    title: '最低成长值',
                    dataIndex: 'min_points'
                },
                {
                    title: '创建时间',
                    dataIndex: 'created_at'
                },
                {
                    title: '操作',
                    with: 100,
                    scopedSlots: { customRender: 'action' },
                }
            ]
        }
    },
    methods: {
    }
}


</script>
  
<style lang="less" scoped></style>